import type { AProps as CoreAProps } from '@main/core-ui';
import { A as CoreA } from '@main/core-ui';
import type { PrivacyCenterTheme } from '@main/theme';
import { timing } from '@main/theme';
import { switchCase } from '@main/utils';
import { darken } from 'polished';
import styled from 'styled-components';

/**
 * Type of A tag
 */
export type AType = 'primary' | 'secondary';

/**
 * Props
 */
export interface AProps extends CoreAProps {
  /** Indicate that the link is selected */
  selected?: boolean;
  /** Type of link */
  type?: AType;
  /** Theme -- only added for helper function use */
  theme: PrivacyCenterTheme;
}

// Get the link color
const getColor = ({ theme, type = 'secondary' }: AProps): string =>
  switchCase<string, [], AType>({
    primary: theme.colors.primary,
    secondary: theme.colors.secondary,
  })(theme.colors.textOnPrimary)(type);

/**
 * An html A tag
 */
export const A = styled(CoreA)<AProps>`
  color: ${getColor};
  text-decoration: none;
  transition: ${timing.shortEase('background-color', 'color')};
  border-radius: 4px;
  outline-color: ${({ theme }) => theme.colors.lightPrimary};
  &:selected {
    text-decoration: none;
  }
  &:visited {
    text-decoration: none;
  }
  &:hover {
    color: ${({ theme, type }) => darken(0.1, getColor({ theme, type }))};
  }
`;
